import { compose } from 'redux';
import { connect } from 'react-redux';
import UserLogin from '../../pages/Login/UserLogin';
import { LoginRequested } from '../../actions/Auth';
import withAuth from '../../common/WithAuth';
import { getSettingCustomTextRequested, getSettingCustomTextClear } from '../../actions/AdminSettingCustom';
import { changeLanguageActions, getLanguageInit, getLanguageRequest } from '../../actions/Locale';

const mapStateToProps = (state) => {
    const isLoading = state.auth.credential.isFetching
    || state.registration.registrationViewer.isFetching
    || state.adminSettingCustom.getCustomText.isFetching;
    return ({
        locale: state.locale.lang.current,
        errors: state.auth.credential.errors,
        isAuthorized: state.auth.credential.isAuthorized,
        credential: state.auth.credential.data,
        eventInfo: state.registration.registrationViewer.data,
        isLoading,
        customText: state.adminSettingCustom.getCustomText.data?.content,
    });
};
const mapDispatchToProps = (dispatch) => ({
    fetchLogin: (params) => {
        dispatch(LoginRequested(params));
    },
    getCustomText: (params) => {
        dispatch(getSettingCustomTextRequested(params));
    },
    clearCustomText: () => {
        dispatch(getSettingCustomTextClear());
    },
    changeLanguage: (param) => {
        dispatch(changeLanguageActions(param));
    },
});

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(UserLogin);
